import {
  ClassOfProperty,
  ImmocheckValuationRequestPayload,
  PropertyTypeAndUsage,
  PropertyTypeNumber,
} from '@/types';

import { Country } from '@smg-real-estate/hg-rets-schema';
import { ImmocheckValuationData, Location } from '../../store/modules/immocheckValuation/types';

export const getResidenceType = (
  propertyType: PropertyTypeNumber,
  classOfProperty: ClassOfProperty,
): PropertyTypeAndUsage => {
  if (propertyType === PropertyTypeNumber.Apartment) {
    // Apartment type
    return classOfProperty === ClassOfProperty.MAIN
      ? PropertyTypeAndUsage.CONDOMINIUM
      : PropertyTypeAndUsage.VACATION_CONDOMINIUM;
  } else {
    // House type
    return classOfProperty === ClassOfProperty.MAIN
      ? PropertyTypeAndUsage.SINGLE_FAMILY_HOUSE
      : PropertyTypeAndUsage.VACATION_HOUSE;
  }
};
export const getFloor = (propertyType: PropertyTypeNumber, floor?: number): number | null => {
  if (propertyType === PropertyTypeNumber.Apartment) {
    return floor || 2; // only for Flats - default: 2nd floor
  }
  return null; // for House type
};

export const mapImmocheckValuationStoreToUbsPayload = (
  payload: ImmocheckValuationData,
): ImmocheckValuationRequestPayload => {
  const { propertyType, floor, classOfProperty } = payload;
  const formattedAddress = mapAddressToUbsPayload(payload.address);
  if (
    typeof propertyType === 'undefined' ||
    !classOfProperty ||
    !formattedAddress ||
    !payload.propertyObjectId ||
    !payload.stateBuildingType
  ) {
    throw new Error('Missing required fields');
  }
  return {
    propertyObjectId: payload.propertyObjectId,
    propertyType: getResidenceType(propertyType, classOfProperty),
    floor: getFloor(propertyType, floor),
    stateBuildingType: payload.stateBuildingType!,
    houseType: propertyType === PropertyTypeNumber.House ? payload.houseType! : null,
    apartmentType: propertyType === PropertyTypeNumber.Apartment ? payload.apartmentType! : null,
    numberOfSeparateGarages: payload.numberOfSeparateGarages || null,
    numberOfExternalParking: payload.numberOfExternalParking || null,
    minergieStandardType: payload.minergieStandardType || 'none',
    constructionQualityType: payload.constructionQualityType || null,
    rooms: payload.rooms || null,
    livingSpace: payload.livingSpace || null,
    volumeIncludingGarageInhouse:
      payload.propertyType === PropertyTypeNumber.House
        ? payload.volumeIncludingGarageInhouse || 0
        : null,
    landArea: payload.propertyType === PropertyTypeNumber.House ? payload.landArea! : null,
    address: { ...formattedAddress },
    buildYear: payload.buildYear || null,
    objectPrice: payload.objectPrice,
  };
};

function mapAddressToUbsPayload(address: Location): {
  streetName?: string;
  postCode?: string;
  townName: string;
  country: string;
} | null {
  if (!address?.city || address.city === '') return null;

  return {
    streetName: address.street,
    postCode: address.postalCode,
    // City and Country are only mandatory for address
    townName: address.city,
    country: address.countryCode || Country.Ch,
  };
}
